import ToastContainers from './Utils/ToastContainer';
import PageNotFound404 from './Errors/PageNotFound404';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Base from './Pages/Base';
import './App.css';
import Home from './Pages/Home';
import FindJob from './Pages/FindJob';
import JobList from './Pages/JobList';
import JobDetails from './Pages/JobDetails';
import UserProfile from './Pages/user/UserProfile';
import UserDashboard from './Pages/user/UserDashboard';
import AppliedJobs from './Pages/user/AppliedJobs';
import BookMarks from './Pages/user/BookMarks';
import DashboardLayout from './Pages/user/DashboardLayout';
import UserSetting from './Pages/user/UserSetting';
import Login from './Pages/Login';
import Registration from './Pages/Registration';
import VerifyEmail from './Pages/VerifyEmail';
import Blogs from './Pages/Blogs';
import BlogsDetail from './Pages/BlogsDetail';
import Contact from './Pages/Contact';
import About from './Pages/About';
import HospitalDashboard from './Pages/hospital/HospitalDashboard';
import HospitalDashboardLayout from './Pages/hospital/HospitalDashboardLayout';
import HospitalProfile from './Pages/hospital/HospitalProfile';
import HospitalSetting from './Pages/hospital/HospitalSetting';
import PostJob from './Pages/hospital/PostJob';
import HospitalJobList from './Pages/hospital/JobList';
import HospitalApplications from './Pages/hospital/Applications';
import ApplicationDetails from './Pages/hospital/ApplicationDetails';
import HospitalChat from './Pages/hospital/HospitalChat';
import PricingPlan from './Pages/hospital/PricingPlan';
import AdminJobsList from './Pages/admin/AdminJobsList';
import HospitalListing from './Pages/admin/HospitalListing';
import HospitalDetail from './Pages/admin/HospitalDetail';
import Subscriptions from './Pages/admin/Subscriptions';
import AdminDashboard from './Pages/admin/AdminDashboard';
import AdminLayout from './Pages/admin/AdminLayout';
import AdminUsers from './Pages/admin/AdminUsers';
import AdminUserDetail from './Pages/admin/AdminUserDetail';
import AdminPayments from './Pages/admin/AdminPayments';
import AdminBlogs from './Pages/admin/AdminBlogs';
import AdminChat from './Pages/admin/AdminChat';
import { AdminProtected, HospitalProtected, UserProtected } from './Security/Protected';
import { RegionProvider } from './context/RegionContext';
import { getRegionContextFromPathname } from './Utils/region';

function App() {
  const { region, basePath } = getRegionContextFromPathname(window.location.pathname || '');

  return (
    <>
      <BrowserRouter basename={basePath || undefined}>
        <RegionProvider initialRegion={region} initialBasePath={basePath}>
          <ToastContainers />

          <Routes>
            <Route path='/' element={<Base><Home /></Base>} />
            <Route path='/find-job' element={<Base><FindJob /></Base>} />
            <Route path='/job-listing' element={<Base><JobList /></Base>} />
            <Route path='/job-details' element={<Base><JobDetails /></Base>} />
            <Route path='/job-details/:id' element={<Base><JobDetails /></Base>} />
            <Route path='/login' element={<Base><Login /></Base>} />
            <Route path='/register' element={<Base><Registration /></Base>} />
            <Route path='/verify-email' element={<Base><VerifyEmail /></Base>} />
            <Route path='/hospital-pricing' element={<Base><PricingPlan /></Base>} />
            <Route path='/blog' element={<Base><Blogs /></Base>} />
            <Route path='/blog-details' element={<Base><BlogsDetail /></Base>} />
            <Route path='/blog-details/:slug' element={<Base><BlogsDetail /></Base>} />
            <Route path='/about' element={<Base><About /></Base>} />
            <Route path='/contact' element={<Base><Contact /></Base>} />
            <Route
              path='/post-job'
              element={
                <HospitalProtected>
                  <Base><PostJob /></Base>
                </HospitalProtected>
              }
            />

            <Route
              element={
                <UserProtected>
                  <Base><DashboardLayout /></Base>
                </UserProtected>
              }
            >
              <Route path='/user-dashboard' element={<UserDashboard />} />
              <Route path='/user-profile' element={<UserProfile />} />
              <Route path='/applied-jobs' element={<AppliedJobs />} />
              <Route path='/bookmark' element={<BookMarks />} />
              <Route path='/user-setting' element={<UserSetting />} />
            </Route>

            <Route
              element={
                <HospitalProtected>
                  <Base><HospitalDashboardLayout /></Base>
                </HospitalProtected>
              }
            >
              <Route path='/hospital-dashboard' element={<HospitalDashboard />} />
              <Route path='/hospital-profile' element={<HospitalProfile />} />
              <Route path='/hospital-jobs' element={<HospitalJobList />} />
              <Route path='/hospital-applications' element={<HospitalApplications />} />
              <Route path='/hospital-applications/:id' element={<ApplicationDetails />} />
              <Route path='/hospital-chat' element={<HospitalChat />} />
              <Route path='/hospital-setting' element={<HospitalSetting />} />
            </Route>

            <Route
              element={
                <AdminProtected>
                  <AdminLayout />
                </AdminProtected>
              }
            >
              <Route path='/admin-dashboard' element={<AdminDashboard />} />
              <Route path='/admin-jobs' element={<AdminJobsList />} />
              <Route path='/hospital-listing' element={<HospitalListing />} />
              <Route path='/hospital-detail/:id' element={<HospitalDetail />} />
              <Route path='/admin-users' element={<AdminUsers />} />
              <Route path='/admin-users/:id' element={<AdminUserDetail />} />
              <Route path='/admin-payments' element={<AdminPayments />} />
              <Route path='/subscriptions' element={<Subscriptions />} />
              <Route path='/admin-blogs' element={<AdminBlogs />} />
              <Route path='/admin-chat' element={<AdminChat />} />
            </Route>

            <Route path='*' element={<PageNotFound404 />} />
          </Routes>
        </RegionProvider>
      </BrowserRouter>
    </>
  );
}

export default App;
